import { Inject } from '@angular/core';
import templateSource from './view.html';
              import { Component } from '@angular/core';

import Wiz from 'src/wiz';
let wiz = new Wiz('/wiz').app('page.signup');
import { OnInit } from '@angular/core';
import { Service } from "src/libs/portal/season/service";

@Component({
    selector: 'wiz-page-signup',
template: templateSource || '',
    styles: [`

/* file: /mnt/data/wiz/project/main/build/src/app/page.signup/view.scss */
:host {
  display: block;
  min-height: 100dvh;
}

.auth-page {
  min-height: 100dvh;
  display: flex;
  align-items: center;
  justify-content: center;
  padding: 32px 20px;
  background: #bfc5c8;
  color: #202027;
  box-sizing: border-box;
}

.auth-card {
  width: 100%;
  max-width: 440px;
  padding: 40px;
  border: 1px solid #e6e6ed;
  border-radius: 24px;
  background: white;
  box-shadow: 0 16px 50px rgba(35, 30, 70, 0.05);
}

.brand {
  display: flex;
  align-items: center;
  gap: 12px;
  margin-bottom: 28px;
  color: #ff5b3b;
  font-size: 24px;
  font-weight: 800;
  letter-spacing: 1px;
}

.brand img {
  display: block;
  flex-shrink: 0;
}

h1 {
  font-size: 28px;
  font-weight: 700;
  letter-spacing: -1px;
  margin: 0 0 12px;
}

.description {
  color: #84848f;
  font-size: 14px;
  line-height: 1.7;
  margin-bottom: 28px;
}

.field {
  margin-bottom: 18px;
}

label {
  display: block;
  font-size: 14px;
  font-weight: 600;
  margin-bottom: 8px;
}

input {
  width: 100%;
  box-sizing: border-box;
  border: 1px solid #dddde6;
  border-radius: 10px;
  padding: 13px 14px;
  background: #fff;
  font-size: 15px;
}

input:focus {
  outline: 3px solid #fff0eb;
  border-color: #ff5b3b;
}

.hint {
  margin-top: 6px;
  font-size: 12px;
  color: #858590;
}

.password-field {
  position: relative;
}

.password-field input {
  padding-right: 68px;
}

.reveal {
  position: absolute;
  right: 12px;
  top: 50%;
  transform: translateY(-50%);
  color: #696278;
  font-size: 12px;
  background: transparent;
  border: 0;
  cursor: pointer;
}

.submit {
  width: 100%;
  padding: 14px;
  border: 0;
  border-radius: 10px;
  background: #ff5b3b;
  color: white;
  font-weight: 600;
  font-size: 15px;
  cursor: pointer;
  margin-top: 6px;
}

.submit:hover {
  background: #e74c2d;
}

button:focus-visible, a:focus-visible {
  outline: 3px solid #ff9d86;
  outline-offset: 3px;
}

button:disabled {
  opacity: 0.6;
  cursor: wait;
}

.error {
  padding: 12px;
  margin-bottom: 16px;
  border-radius: 8px;
  color: #a82d3b;
  background: #fff0f2;
  font-size: 13px;
  line-height: 1.6;
}

.success {
  padding: 12px;
  margin-bottom: 16px;
  border-radius: 8px;
  color: #356548;
  background: #edf8f0;
  font-size: 13px;
}

.switch {
  text-align: center;
  color: #858590;
  font-size: 13px;
  margin: 24px 0 0;
}

a {
  color: #e74c2d;
  font-weight: 600;
  text-decoration: none;
}

@media (max-width: 480px) {
  .auth-page {
    padding: 20px 16px;
  }
  .auth-card {
    padding: 28px 22px;
    border-radius: 18px;
  }
}`],
})
export class PageSignupComponent implements OnInit {
    public username = '';
    public password = '';
    public showPassword = false;
    public busy = false;
    public error = '';
    constructor(@Inject( Service) public service: Service) { }
    public async ngOnInit() {
        await this.service.init();
        if (this.service.auth.status) {
            this.service.href('/dashboard');
        }
        await this.service.render();
    }

    public name = '';
    public confirmation = '';
    public async submit() {
        if (this.busy) return;
        this.error = '';
        if (this.password !== this.confirmation) {
            this.error = '비밀번호 확인이 일치하지 않습니다.';
            return;
        }
        this.busy = true;
        try {
            const res = await wiz.call('register', {
                username: this.username, password: this.password,
                name: this.name, confirmation: this.confirmation
            });
            if (res.code === 200) {
                this.service.href('/login?registered=1');
                return;
            }
            this.error = res.data?.message || '회원가입하지 못했습니다. 입력 내용을 확인해주세요.';
        } catch (e) {
            this.error = '서버에 연결하지 못했습니다. 다시 시도해주세요.';
        } finally {
            this.busy = false;
            await this.service.render();
        }
    }
}

export default PageSignupComponent;